/**
 * @file コンポーネント：フル動画ページ編集モーダル執刀医権限ユーザーリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContents = styled.div``;

export const StyledContentsSelected = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px 4px 0;
`;

export const StyledContentsSelectedItem = styled.li`
    margin: 0 8px 8px 0;
`;

export const StyledContentsSelectedItemButton = styled.button`
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #000000;
    font-size: 14px;
    line-height: 18px;
`;

export const StyledContentsSelectedItemButtonIcon = styled.span`
    margin-right: 4px;
`;

export const StyledContentsSelectedItemButtonText = styled.span``;

export const StyledContentsTable = styled.table`
    width: 100%;
    margin: 12px 0;
    border-spacing: unset;
`;

export const StyledContentsTableTbody = styled.tbody``;

export const StyledContentsTableTd = styled.td`
    height: 42px;
    padding: 4px;
    color: #000000;
    font-size: 13px;
    line-height: 16px;
`;

export const StyledContentsTableTdAction = styled(StyledContentsTableTd)`
    width: 120px;
    text-align: center;
`;

export const StyledContentsTableTr = styled.tr`
    &:nth-of-type(odd) {
        background-color: #acadae;
    }
`;
